import { defineMessages } from 'react-intl';

export default defineMessages({
    pageTitle: {
        id: 'ax_servicerequest.views.new-service-request.title',
        defaultMessage: 'Create new service'
    },
    missingClaimSelectedErrorTitleMsg: {
        id: 'ax_servicerequest.views.new-service-request.MissingClaimSelected.Title',
        defaultMessage: 'Missing claim number'
    },
    missingClaimSelectedErrorBodyMsg: {
        id: 'ax_servicerequest.views.new-service-request.MissingClaimSelected.Body',
        defaultMessage: 'You must select a claim number before going to step 2'
    },
});
